import { render } from "./AuditingView.vue?vue&type=template&id=539f096e&ts=true"
import script from "./AuditingView.vue?vue&type=script&lang=ts"
export * from "./AuditingView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__